import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AdminUserDto } from '../../../api/interfaces/addUser';
import { useLoader } from '../../../Loader/LoaderContext';
import { API_ENDPOINTS } from '../../../api';
import { getService } from '../../../servce/ApisService';
import { getDotColor, getRoleDisplayName, getSHiftDisplayName, getStatusClass, getStatusDisplayName } from '../../../utility/RolesUtility';

const ViewDetails: React.FC = () => {
  const[data,setData]=useState<AdminUserDto>();
  const { setLoading } = useLoader();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
    const navigate = useNavigate();
    useEffect(() => {
      fetchVehicles();
    }, []);
    const fetchVehicles = async () => {
      setLoading(true);
      try {
        let url:any;
        if(userInfo.roles ==='SUPER_ADMIN'){
          url=API_ENDPOINTS.adminUserData
        }else if(userInfo.roles ==='SALES_ADMIN'){
          url=API_ENDPOINTS.salesUserData
        }else if(userInfo.roles ==='CONTENT_ADMIN'){
          url=API_ENDPOINTS.contentUsersData
        }else if(userInfo.roles ==='SALES_MANAGER'){
          url=API_ENDPOINTS.salesMangerUsersData
        }else if(userInfo.roles ==='SALES_TEAM_LEAD'){
          url=API_ENDPOINTS.salesTlUsersData
        }
        const response = await getService(url+"?appUserId="+userId);
        console.log(response);
        setData(response.data)
        setTimeout(() => {
          setLoading(false)
        }, 1000);
      } catch (error) {
        setTimeout(() => {
          setLoading(false)
        }, 1000);
        console.error('Error fetching vehicle data:', error);
      }
      finally{
       
      }
    };
    const addedByName = searchParams.get('addedByName');
    const users=() =>{
        navigate('/portals/userManagmnt/viewUser')
      }
      const usersScreen=() =>{
        navigate(-1)
     }
     const editProfile=(data:any) =>{
        navigate('/portals/userManagmnt/addUser?appUserId='+data?.appUserId)
     }
     const addedName=() =>{
      navigate(-1)
     }
 

  return (
    <div className="h-full py-2 w-full">
      <div className='flex items-center cursor-pointer mb-4'>
        <h2 className='mr-2 text-gray-700 font-semibold text-sm' onClick={users}>Users</h2> {addedByName && <><img src='/images/arrowIcons.svg' className='mr-2' />  <span className='text-gray-700 font-semibold text-sm mr-2' onClick={addedName}>{addedByName}'s team</span></>} <img src='/images/arrowIcons.svg' className='mr-2' /> <span className='text-gray-400 font-semibold text-sm'>{data?.firstName} {data?.lastName}</span>
      </div>
      {/* <div className='flex items-center mb-3 mt-2 cursor-pointer' onClick={usersScreen}>
       <img src='/images/back.svg' className='mr-2' />
        <h1 className="text-2xl font-bold mb-2 text-[#2D2E2F]">{data?.firstName} {data?.lastName}</h1>
      </div> */}
      <div className='bg-white p-4 rounded-[8px]'>
   
        <div className='flex justify-between items-center pb-4'>
           <div className='flex items-center'>
           <img src={data?.profilePic?.documentUrl ? data?.profilePic?.documentUrl :'/images/userImg.svg'} className='rounded-full w-[70px] h-[70px] mr-3' />
           <div>
            <div className='flex'>
            <h2 className='text-gray-900 font-bold text-[20px] mr-3'>{data?.firstName} {data?.lastName}</h2>
            <div className='flex justify-between items-center'><span className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClass(data?.status)}`}>
                  <span className="inline-block w-2 h-2 mr-2 rounded-full" style={{ backgroundColor: getDotColor(data?.status) }}></span>
                 {/* {user.status ? 'Active' : 'Inactive'} */}
                 {getStatusDisplayName(data?.status)}
                 </span>
                 </div>
            {/* <div className='flex'>
                <span className={`px-4 py-1.5 rounded-full text-xs font-semibold ${'bg-[#D1FAE5] text-[#065F46]'}`}>
                  <span className="inline-block w-2 h-2 mr-2 rounded-full" style={{ backgroundColor: '#34D399' }}></span>
                 Active
                </span>
               
                </div> */}
               </div>
               <p className='text-gray-600 text-base mt-1'>{data?.email}</p>
            </div>
                
           </div>
           {
                            (userInfo?.roles ==='SUPER_ADMIN' ||
                               userInfo?.roles ==='SALES_ADMIN' ||
                                userInfo?.roles ==='CONTENT_ADMIN') &&
           <div className='border border-gray-300 py-2 px-4 text-gray-600 font-bold text-base rounded-[8px] cursor-pointer' onClick={() =>editProfile(data)}>
            Edit User
           </div>
}
          
        </div>
    <p className='border border-gray-200'></p>
    <div className='grid grid-cols-3 px-4 py-5'>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Name</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.firstName} {data?.lastName}</p>
</div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Email</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.email}</p>
</div>
<div></div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Role</h2>
    <p className='text-base font-semibold text-gray-900'>{getRoleDisplayName(data?.roles[0]?.name)}</p>
</div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Country</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.mtCountryDto?.name ? data?.mtCountryDto?.name :'NA'}</p>
</div>
<div></div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Address</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.address ? data?.address :'NA'}</p>
</div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Phone Number</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.phoneNo ? data?.phoneNo :'NA'}</p>
</div>
<div></div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Alternative Number</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.altrntvePhoneNo ? data?.altrntvePhoneNo : 'NA'}</p>
</div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Blood Group</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.bloodGroup ?data?.bloodGroup :'NA'}</p>
</div>
<div></div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Employee Id</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.employeeId ? data?.employeeId :'NA'}</p>
</div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Employee Category</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.employeeCategory ? data?.employeeCategory : 'NA'}</p>
</div>
<div></div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Salary</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.salary ? data?.salary : 'NA'}</p>
</div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Leaves</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.leaves ? data?.leaves :'NA'}</p>
</div>
<div></div>
<div className='py-3'>
    <h2 className='text-gray-700 font-normal text-sm'>Shift</h2>
    <p className='text-base font-semibold text-gray-900'>{data?.shift ? getSHiftDisplayName(data?.shift) : 'NA'}</p>
</div>

      </div>
      </div>
      
    
    </div>
  )
}

export default ViewDetails
